import React from "react";
// group-off-outline Material Symbols

const GroupOffOutline = props => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      {...props}
    >
      <path
        fill="currentColor"
        d="M20.475 23.3L17 19.825V20H1v-2.8q0-.85.438-1.562T2.6 14.55q1.55-.775 3.15-1.162T9 13q.3 0 .613.013t.612.037L9.175 12H9q-1.65 0-2.825-1.175T5 8v-.175L.675 3.5L2.1 2.075l19.8 19.8zM16.65 13.15q1.275.15 2.4.513t2.1.887q.9.5 1.375 1.112T23 17v3h-.125l-4-4q-.225-.825-.788-1.562T16.65 13.15M9 15q-1.4 0-2.775.338T3.5 16.35q-.225.125-.363.35T3 17.2v.8h12v-.175l-2.175-2.175q-.95-.325-1.912-.487T9 15m5.05-3.825q.475-.7.713-1.5T15 8q0-1.05-.362-2.025T13.6 4.2q.35-.125.7-.162T15 4q1.65 0 2.825 1.175T19 8t-1.237 2.825T14.875 12zm-1.45-1.45l-1.6-1.6V8q0-.825-.587-1.412T9 6h-.125l-1.6-1.6q.4-.2.825-.3T9 4q1.65 0 2.825 1.175T13 8q0 .475-.1.9t-.3.825M9.95 7.05"
      ></path>
    </svg>
  )
}

export default GroupOffOutline;

